<template>
<div>
<!-- <pre>{{countryObj}}</pre> -->
  <div class="has-text-centered">
    
    <router-link v-if="country" v-bind:to="'/countries/' + $countrymap[placeObj.id]">
      <div class="card place-card" style="margin-left:auto; margin-right:auto; padding:60px 10px;  background-blend-mode:overlay; 
        background-position: center center, center center; background-size: cover, cover;"
        
        :style="thumbnail != '' ? 
          {
            
            background: 'url(\'' + thumbnail + '\') rgba(255,255,255,0.84)',
            backgroundPosition: 'center center, center center',
            backgroundSize: 'cover, cover',
            backgroundRepeat: 'no-repeat, no-repeat'
            } 
            : 
            ''"
      > 
      
    
                  <router-link class="is-3 is-4-mobile title" style="display:inline-block; margin-bottom:0px" v-bind:to="'/' + 'countries' + '/' + $countrymap[placeObj.id]">{{$countrymap[placeObj.id]}}</router-link>

      </div>
      </router-link>

      <router-link v-if="state" v-bind:to="'/countries/United States/' + placeObj.name">
        <div class="card place-card" style="margin-left:auto; margin-right:auto; padding:60px 10px;  background-blend-mode:overlay; 
        background-position: center center, center center; background-size: cover, cover;"
        
        :style="thumbnail != '' ? 
          {
            
            background: 'url(\'' + thumbnail + '\') rgba(255,255,255,0.84)',
            backgroundPosition: 'center center, center center',
            backgroundSize: 'cover, cover',
            backgroundRepeat: 'no-repeat, no-repeat'
            } 
            : 
            ''"
      > 
     
    
                  <router-link class="is-3 is-4-mobile title" style="display:inline-block; margin-bottom:0px" v-bind:to="'/' + 'countries/United States/' + placeObj.name">{{placeObj.name + ", US"}}</router-link>

      </div>
      </router-link>
  </div>
  </div>
</template>

<script>
// import {continent_map} from "../data.js";
export default {
  name: 'PlaceCardSimple',
  props: ['placeObj', 'country', 'state', 'subregion'],
  data () {
    return {
      thumbnail: "",
      thumbnails: {'Arizona': 'https://firebasestorage.googleapis.com/v0/b/bike-trip-directory.appspot.com/o/images%2Fazt-exploring-wild.jpg?alt=media&token=5c81b914-fa26-4086-98ec-3d26e4d5a75e' }
    }
  },
  methods: {
  
  },
  mounted() {
    var that = this;
    // console.log(this.placeObj);
    if (this.country) {
      this.$db.collection("countries").doc(this.placeObj.id).get()
      .then(function(doc) {
        
        if (doc.exists && doc.data().thumbnail) {
          // console.log(doc.data());
          that.thumbnail = doc.data().thumbnail;
        } else {
          that.$db.collection("pages").where('countries', 'array-contains', that.placeObj.id).orderBy("year", "desc").orderBy("added", "desc").limit(1).get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
                // doc.data() is never undefined for query doc snapshots
                that.thumbnail = doc.data().image;
            
            });
          })
          .catch(function(error) {
              console.log("Error getting thumbnail for country: " + that.placeObj.id, error);
              that.loading = false;
          })
        }
      })
      .catch(function(error) {
          console.log("Error getting thumbnail for country: " + that.placeObj.id, error);
          that.loading = false;
      });
    } else if (this.state) {
      if (this.thumbnails.hasOwnProperty(this.placeObj.name)) {
        this.thumbnail = this.thumbnails[this.placeObj.name];
      } else {
        that.$db.collection("pages").where('regions', 'array-contains', that.placeObj.name).orderBy("year", "desc").orderBy("added", "desc").limit(1).get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
                // doc.data() is never undefined for query doc snapshots
                that.thumbnail = doc.data().image;
            
            });
          })
          .catch(function(error) {
              console.log("Error getting thumbnail for country: " + that.placeObj.id, error);
              that.loading = false;
          })
      }
      
    }
    
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .place-card  {
    color:black;
    font-weight:bold;
    /* height: 150px; */
    /* padding: 10px 50px; */
  }
  
</style>


// WEBPACK FOOTER //
// src/components/PlaceCardSimple.vue